module.exports = __webpack_public_path__ + "img/michal-paczka-terapia-uzaleznienia-gliwice.ffcf1663.jpg";